<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <g clip-path="url(#clip0_127_933)">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M11.7966 1.01695V6.91525C11.7966 7.13991 11.6145 7.32203 11.3898 7.32203C11.1652 7.32203 10.9831 7.13991 10.9831 6.91525L10.7797 1.22034C10.7797 1.10801 10.6886 1.01695 10.5763 1.01695H1.22034C1.10801 1.01695 1.01695 1.10801 1.01695 1.22034L0.813559 6.91525C0.813559 7.13991 0.631438 7.32203 0.40678 7.32203C0.182121 7.32203 0 7.13991 0 6.91525V1.01695C0 0.455304 0.455304 0 1.01695 0H10.7797C11.0494 0 11.308 0.107143 11.4988 0.297857C11.6895 0.488572 11.7966 0.747237 11.7966 1.01695Z"
        fill="#F2F5F8" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.96616 1.62708V5.89826H8.54243H3.2543H1.83057V1.62708H9.96616Z"
        fill="#4C8056" />
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M1.83043 1.62713V5.89832L0.813477 6.91527V1.01696C0.813612 0.959571 0.837989 0.904908 0.880595 0.866455L1.83043 1.62713Z"
        fill="#47B840" />
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M10.9833 1.01696V6.91527L9.96631 5.89832V1.62713L10.9161 0.866455C10.9587 0.904908 10.9831 0.959571 10.9833 1.01696Z"
        fill="#47B840" />
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M10.9161 0.86648L9.96628 1.62716H1.83069L0.880859 0.86648C0.918161 0.832575 0.966723 0.81373 1.01713 0.813599H10.7798C10.8302 0.81373 10.8788 0.832575 10.9161 0.86648Z"
        fill="#47B840" />
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M5.89821 12C5.78588 12 5.69482 11.909 5.69482 11.7967V9.35598C5.69482 9.24365 5.78588 9.15259 5.89821 9.15259C6.01054 9.15259 6.1016 9.24365 6.1016 9.35598V11.7967C6.1016 11.909 6.01054 12 5.89821 12Z"
        fill="#47B840" />
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M5.08474 11.3899C4.97241 11.3899 4.88135 11.2988 4.88135 11.1865V9.35598C4.88135 9.24365 4.97241 9.15259 5.08474 9.15259C5.19707 9.15259 5.28813 9.24365 5.28813 9.35598V11.1865C5.28813 11.2988 5.19707 11.3899 5.08474 11.3899Z"
        fill="#47B840" />
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M6.71218 11.3899C6.59985 11.3899 6.50879 11.2988 6.50879 11.1865V9.35598C6.50879 9.24365 6.59985 9.15259 6.71218 9.15259C6.82451 9.15259 6.91557 9.24365 6.91557 9.35598V11.1865C6.91557 11.2988 6.82451 11.3899 6.71218 11.3899Z"
        fill="#47B840" />
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M2.35764 8.62556L0.809847 10.1734C0.763752 10.2196 0.742652 10.2851 0.753124 10.3496C0.763596 10.414 0.804366 10.4695 0.862729 10.4988L1.24734 10.6912C1.34566 10.7404 1.4653 10.7026 1.51744 10.6058L2.51914 8.74576C2.54324 8.70131 2.53103 8.64589 2.49046 8.6157C2.4499 8.58551 2.39331 8.58971 2.35764 8.62556Z"
        fill="#FFE400" />
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M9.43943 8.62556L10.9872 10.1734C11.0333 10.2196 11.0544 10.2851 11.0439 10.3496C11.0335 10.414 10.9927 10.4695 10.9343 10.4988L10.5497 10.6912C10.4514 10.7404 10.3318 10.7026 10.2796 10.6058L9.27793 8.74576C9.25383 8.70131 9.26604 8.64589 9.30661 8.6157C9.34717 8.58551 9.40376 8.58971 9.43943 8.62556Z"
        fill="#FFE400" />
    </g>
    <defs>
      <clipPath id="clip0_127_933">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
